export default {
  // 全局
  global: {
    search: '搜索',
    change: '更改',
    narrowDown: '筛选',
    add: '创建',
    edit: '编辑',
    delete: '删除',
    confirm: '确认',
    cancel: '取消',
    all: '全部',
    controls: '操作',
    inputPlaceholder: '请输入',
    selectPlaceholder: '请选择',
    reset: '重置',
    allReset: '全部重置',
    addItems: '添加项目',
    createTime: '创建时间',
    updateTime: '更新时间',
    ASC: '升序',
    DESC: '降序',
    export: '导出',
    success: '成功',
    user: '用户',
    addSuccess: '添加成功',
    editSuccess: '编辑成功',
    deleteSuccess: '删除成功',
    operationSuccess: '操作成功',
    clearSuccess: '清除成功',
    refreshCachListSucess: '刷新缓存列表成功',
    refreshKeyListSuccess: '刷新键名列表成功',
    cleanCacheName: '清理缓存名',
    cleanCacheKeyName: '清理缓存键名',
    cleanAllCacheSuccess: '清理全部缓存成功',
    unlockSuccess: '解锁成功',
    cancelAccessSuccess: '取消访问成功',
    editPWSuccess: '密码已更改',
    genCustomPathSuccess: '生成自定义路径成功',
    personal: '个人中心',
    layoutSetting: '布局设置',
    logout: '登出',
    layoutSize: '布局大小',
    plsInput: '请输入',
    plsSelect: '请选择',
    confirmDelete: '确认删除吗',
    large: '大',
    default: '默认',
    small: '小',
    status: '状态',
    operation: '操作',
    collapse: '展开/折叠',
    hideSidebar: '隐藏侧边栏',
    showSidebar: '显示侧边栏',
    switchToLightMode: '切换到浅色模式',
    switchToDarkMode: '切换到深色模式',
    cinemaChainStatus: '影院连锁状态',
    deptStatus: '部门状态',
    sort: '排序',
    filter: '筛选',
    displaySort: '显示顺序',
    plsInputValidEmail: '请输入有效的电子邮件地址',
    plsInputValidPhone: '请输入有效的手机号码',
    code: '代码',
    country: '国家',
    upperLocation: '上级地区',
    invalidTime: '时间格式不正确',
    invalidTime2: '结束时间必须晚于开始时间',
    close: '关闭',
    cancelAccess: '取消授权',
    startDate: '开始日期',
    endDate: '结束日期',
    import: '导入',
    resetPWD: '重置密码',
    dragFile: '将文件拖到这里',
    or: '或',
    clickUpload: '点击上传',
    updateExistData: '更新现有用户数据吗？',
    onlyImportFile: '只能导入xls、xlsx格式的文件',
    downloadTemplate: '下载模板',
    limitLength: '长度必须在{min}和{max}之间',
    invalidEmail: '无效的电子邮件地址',
    invalidPhone: '无效的手机号码',
    on: '开',
    off: '关',
    confirmActiveUser: '确认{userName}用户{text}吗？',
    confirmCancelAccess: '确认取消用户{userName}的角色{roleName}吗？',
    cancelSelectedAccess: '取消选定用户的所有授权数据吗？',
    plsInputNewPWD: '请输入{userName}的新密码',
    tips: '提示',
    userImport: '用户导入',
    importResult: '导入结果',
    isLoading: '加载中，请稍候',
    invalidNumber: '必须是有效的数字',
  },
  user: {
    title: '账号',
    name: '用户名',
    phone: '手机号码',
    userId: '用户ID',
    abbr: '用户昵称',
    dept: '部门',
    belongDept: '所属部门',
    belongCinema: '所属影院',
    email: '邮箱',
    pwd: '用户密码',
    gender: '用户性别',
    position: '职位',
    role: '角色',
    remark: '备注',
    assignRole: '分配角色',
  },
  systemRole: {
    title: '权限组',
    name: '角色名',
    permissionChar: '权限字符',
    permissionCharExample: '在控制器中定义的权限字符。例如：@PreAuthorize(`@ss.hasRole("admin")`)',
    permissionRange: '权限范围',
    roleId: '角色ID',
    roleSort: '角色排序',
    sort: '显示顺序',
    menuPer: '菜单权限',
    dataper: '数据权限',
    checked: '全选/全不选',
    parChild: '父子链接',
    assignUser: '分配用户',
    addUser: '添加用户',
    allCancelAccess: '全部取消授权',
    allDataPer: '所有数据权限',
    cusDataPer: '自定义数据权限',
    deptDataPer: '部门数据权限',
    deptChildDataPer: '部门及以下数据权限',
    onlySelfDataPer: '仅自身数据权限',
    confirmActiveRole: '确认{roleName}角色{text}吗？',
    assignDataPer: '分配数据权限',
  },
  system: {
    home: '首页',
    title: 'CINEIGA',
    systemManage: {
      title: '系统管理',
      menu: '菜单管理',
      position: '职位管理',
      dict: '字典管理',
      config: '参数设置',
      notice: '通知公告',
      log: {
        title: '日志管理',
        operLog: '操作日志',
        logininfor: '登录日志',
      },
    },
    monitor: {
      online: '在线用户',
      job: '定时任务',
      druid: '数据监控',
      server: '服务器监控',
      cache: '缓存监控',
      cacheList: '缓存列表',
    },
    tool: {
      title: '系统工具',
      build: '表单生成',
      gen: '代码生成',
      swagger: '系统接口',
    },
  },
  // 电影
  movie: {
    id: 'ID',
    movieId: '作品代码',
    mwId: 'MW作品ID',
    eglId: 'EGL作品ID',
    title: '作品标题',
    isTitleConfirmed: '临时标题标志',
    titleKana: '标题假名',
    titleKana8: '假名8',
    aliases: '别名',
    originalTitle: '原标题',
    englishTitle: '英文标题',
    osd: 'ODS',
    seriesId: '系列',
    seriesSequence: '系列顺序',
    seriesGenreIds: '系列类型',
    isJapaneseMovie: '洋片/日本片',
    duration: '放映时间',
    genreIds: '类型',
    highlightIds: '亮点',
    category: '电影审查',
    productionYear: '制作年份',
    countryIds: '制作国家',
    countriesNote: '国家备注',
    companyIds: '发行公司',
    castRoles: '演员表',
    creditNote: '制作备注',
    openDateType: '公开日期类型',
    openDate: '公开日期值',
    openSeasonYear: '年',
    openSeasonMonth: '月',
    openSeasonMonthPeriod: '月份周期',
    openSeasonMonthSolarTerm: '时令',
    openString: '公开日期字符串',
    openConfirm: '公开日期确认',
    copyright: '版权',
    catchphrase: '口号',
    commentary: '解说',
    story: '剧情简介',
    officialPageUrl: '官方网站',
    trailerYoutubeUrl: '预告片',
    officialXUrl: 'X (旧Twitter)',
    officialInstagramUrl: 'Instagram',
    officialFacebookUrl: 'Facebook',
    imdbUrl: 'IMDb',
    remark: '作品备注',
    posters: '海报图片',
    screenshots: '剧照',
    scheduleCount: '放映次数',
    scheduleCountIn10Days: '最近10天的放映次数',
    headCinema: '总部影院',
    headCinemaComment: '总部影院评论',
    movieStatus: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    delFlag: '删除标志',
    // 列表
    movieList: {
      search: '按标题搜索',
      sorting: '排序',
      genreIds: '类型',
      seriesId: '系列',
      sortType: '创建顺序',
    },
    // 详情
    movieDetail: {
      image: '图片',
      baseInfo: '基本信息',
      detailSet: '详细设置',
      castSet: '演员设置',
      moreInfo: '详细信息',
      filmInfo: '作品信息',
      otherInfo: '其他信息',
    },
    // 演员
    movieCharacter: {
      cast: '人名',
      role: '角色',
      roleName: '角色名',
    },
  },
  // 自定义上传组件
  imageSortUpload: {
    title: '图片列表',
    imageUpload: '请上传图片',
    multiple: '※可以上传多个',
    icon: '选择图片',
    drop: '拖放',
    dropUpload: '上传图片',
    sort: '显示顺序',
    preview: '预览',
    posters: '海报图片',
    screenshots: '剧照图片',
  },
  // Cinema
  cinema: {
    id: 'ID',
    cinemaId: '影院ID',
    eglId: 'EGL影院ID',
    name: '影院名称',
    nameKana: '影院名称假名',
    cinemaClassId: '影院分类',
    cinemaChainId: '影院系列',
    businessHours: '营业时间',
    noOfScreen: '影厅数量',
    noOfSeat: '座位数量',
    screens: '影厅',
    areaId: '地区',
    prefectureId: '都道府县',
    districtId: '地区',
    iAreaId: 'i-地区',
    postcode: '邮政编码',
    cityName: '市区町村',
    address1: '地址1',
    address2: '地址2',
    latitude: '纬度',
    longitude: '经度',
    latitude_jp_degree: '日本纬度（度）',
    latitude_jp_minute: '日本纬度（分）',
    latitude_jp_second: '日本纬度（秒）',
    longitude_jp_degree: '日本经度（度）',
    longitude_jp_minute: '日本经度（分）',
    longitude_jp_second: '日本经度（秒）',
    access: '访问',
    accessDetail: '详细访问信息',
    phoneInfo: '电话信息',
    phoneNo: '电话号码',
    businessPhoneNo: '采访用电话',
    faxNo: '传真号码',
    inquiryInfo: '查询',
    haveParking: '是否有停车场',
    parking: '停车场数量',
    isParkingFree: '停车场收费分类',
    wheelchairSeating: '轮椅座位数量',
    facilityIds: '设施',
    price: '价格',
    discount: '折扣',
    twitterUrl: 'X (旧Twitter) URL',
    facebookUrl: 'Facebook URL',
    instagramUrl: 'Instagram URL',
    lineUrl: 'LINE URL',
    email: '电子邮件',
    hpUrl: '影院URL',
    scheduleDataFrom: '获取日程的方式',
    cpUuid: 'CP用UUID',
    cp2Uuid: 'CP2用UUID',
    scheduleCount: '放映次数',
    cinemaStatus: '状态',
    statusNote: '状态备注',
    note: '备注',
    userInCharge: '负责人',
    cinemaDetail: {
      baseInfo: '基本信息',
      detailSet: '详细设置',
      castSet: '影厅设置',
      otherInfo: '其他信息',
      snsInfo: 'SNS信息',
      cinemaInfo: '影院信息',
      contactInfo: '联系信息',
      locationInfo: '位置信息',
    },
    screen: {
      id: '影厅ID',
      name: '名称',
      numberOfSeats: '座位数量',
      numberOfWheelChairSeats: '轮椅座位数量',
      screenFacilities: '影厅设施',
      soundSystem: '音响设备',
    },
    // 详情
    movieDetail: {
      image: '图片',
      baseInfo: '基本信息',
      detailSet: '详细设置',
      castSet: '演员设置',
      moreInfo: '更多信息',
      filmInfo: '作品信息',
      otherInfo: '其他信息',
    },
    // 演员
    movieCharacter: {
      cast: '人名',
      role: '角色',
      roleName: '角色名称',
    },
  },
  // 公司
  company: {
    search: {
      placeholder: '按公司名称搜索',
    },
    table: {
      name: '名称',
      abbreviation: '简称',
      jpCompanyName: '公司名称（假名）',
      telephoneNumber: '电话号码',
      companyType: '公司类型',
      createTime: '创建时间',
      updateTime: '更新时间',
    },
    dialog: {
      title: '编辑公司',
    },
    parentId: '上级部门',
  },
  cast: {
    title: '演职人员',
    search: {
      name: '姓名',
      originalName: '英文名/原名',
      nameKana: '姓名假名',
      writtenName: '姓名（刊登）',
      sex: '性别',
      birthPlace: '出生地',
      birth: '出生日期',
      mainRole: '主要角色',
      debut: '首次亮相作品',
      profile: '个人简介',
      samePerson: '同一人物',
    },
  },
  // 国家
  country: {
    title: '国家',
    englishName: '英文名',
    japaneseName: '日文名',
    abbr: '缩写',
  },
  // 视点
  highlight: {
    title: '亮点',
    name: '名称',
  },
  // i-地区
  iArea: {
    name: 'i-地区',
    nameKana: 'i-地区假名',
  },
  // 电影系列
  movieSeries: {
    title: '作品系列',
    search: {
      name: '名称',
      originalName: '英文名/原名',
      nameKana: '假名',
      commentary: '解说',
    },
  },
  // 角色
  role: {
    title: '角色',
    roleList: {
      name: '名称',
      abbr: '缩写',
    },
  },
  // 类型
  genre: {
    name: '作品类型',
  },
  // 版本
  version: {
    title: '放映会版本',
    name: '名称',
    version0: '2D/3D',
    version1: '屏幕规格',
    version1Tab: '屏幕企划',
    version2: '字幕/配音',
    version3: '其他版本',
  },
  // 设施
  facility: {
    title: '剧场设施',
    name: '名称',
  },
  // 影院系列
  cinemaChain: {
    title: '影院系列',
    name: '名称',
    code: '罗马字编码',
    total_no_of_cinemas: '总影院数量',
    total_no_of_screens: '总影厅数量',
    total_no_of_seats: '总座位数量',
    membership: '会员制度',
    official_page_url: '官方网站（URL）',
  },
  location: {
    title: '地区',
    locationSearch: '按地区搜索',
    name: '名称',
    area: '区域',
    prefecture: '都道府县',
    district: '市区町村',
    sort: '地区列表',
    nameKana: '市区町村假名',
  },
  season: {
    search: '按季节名搜索',
    name: '季节',
  },
  // 作品系列类型
  seriesGenre: {
    name: '作品系列类型',
  },
  // 影院分类
  cinemaClass: {
    name: '影院分类',
  },
  // 音响系统
  soundSystem: {
    name: '音响系统',
  },
  // 合并电影
  mergeMovie: {
    name: '合并',
    mergeToTableName: '目标作品',
    mergeFromTableName: '要合并到目标作品的作品',
    title: '电影名称/ID',
    englishTitle: '英文名',
    productionYear: '制作年份',
    openString: '上映日期',
    countriesNote: '制作国家备注',
  },
  // 日程安排
  schedule: {
    title: '日程安排',
    selectedDelete: '批量删除选定日程',
    allDelete: '批量删除所有日程',
    plsEnter: '请进行自由输入或筛选选择',
    search: {
      movieName: '上映作品名称',
      cinemaName: '上映影院名称',
      cinemaChain: '上映影院连锁',
    },
    list: {
      id: '日程ID',
      feature_id: '上映特集名称',
      screen_id: '上映屏幕',
      version1: '屏幕规格',
      version2: '字幕/配音',
      version3: '其他版本',
      version4: '上映分类',
      startTime: '开场时间',
      endTime: '结束时间',
      ticketingUrl: '网络预订URL',
      onlineSalesStartTtime: '网络预订开始时间',
      onlineSalesEndTime: '网络预订结束时间',
      ticketOfficeSalesStartTime: '售票开始时间（窗口）',
      ticketOfficeSalesEndTime: '售票结束时间（窗口）',
      dataFrom: '日程获取方式',
      time: '上映时段',
    },
    form: {
      cinema: '电影院',
      movieName: '作品',
      scheduleSeriesId: '上映特集',
      date: '上映日期',
      screen: '屏幕',
      startTime: '上映时间',
      endTime: '结束时间',
      addRow: '添加上映时间',
      resetAll: '重置所有输入内容',
      submit: '将输入内容作为日程添加',
    },
  },
  // 日程系列
  scheduleSeries: {
    search: '按日程系列名称搜索',
    title: '日程系列列表',
    name: '名称',
    nameKana: '假名',
    startDate: '上映开始日期',
    note: '备注',
  },
};
